import { graphql } from "gql.tada";
import { RichEntryFragment } from "@queries/fragments/RichEntryFragment";
import { MetadataFragment } from "@queries/fragments/MetadataFragment";
import { TitleSectionFragment } from "@queries/fragments/TitleSectionFragment";

export const GetCreativeSpecsPageById = graphql(
  `
    query GetCreativeSpecsPageById($id: String!, $locale: String, $preview: Boolean) {
      creativeSpecsPage(id: $id, preview: $preview, locale: $locale) {
        __typename
        slug
        metadata { ...MetadataFragment }
        titleSection { ...TitleSectionFragment }
        faq {
          sys {
            id
          }
          faqTitle
          faqFilterTitle
          faqItemsCollectionCollection(limit: 50) {
            items {
              sys {
                id
              }
              title
              filterTagText
              description {
                ...RichEntryFragment
              }
            }
          }
        }
      }
    }
  `,
  [RichEntryFragment, MetadataFragment, TitleSectionFragment]
);
